import { Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";
import { IconButton } from "@src/appV2/redesign/components/IconButton";
import { useEffect } from "react";

interface PlacementFilterTooltipContentProps {
  onClose: () => void;
}
export function PlacementFilterTooltipContent(props: PlacementFilterTooltipContentProps) {
  const { onClose } = props;

  useEffect(() => {
    return () => {
      onClose();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Stack position="relative" pr={4} alignItems="center">
      <Text semibold variant="caption" color={(theme) => theme.palette.primary.contrastText}>
        Filter by job type, schedule, location and more!
      </Text>
      <IconButton
        sx={(theme) => ({
          color: theme.palette.primary.contrastText,
          position: "absolute",
          top: -3,
          right: -5,
        })}
        variant="ghost"
        size="xSmall"
        iconType="close"
        onClick={onClose}
      />
    </Stack>
  );
}
